module.exports = __webpack_public_path__ + "static/media/the_dog_house.pragmaticplay.093739d9.jpeg";